import React, { useState } from "react";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
const backend = await new Backend().init();

export default function ResetPassword({ user_id }) {
  const [isLoading, setLoading] = useState(false);

  const Update = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user_id,
    };

    backend.reset_password(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        toast.success(r.message);
      } else {
        toast.error(r.message);
      }
    });
  };

  const baseStyle =
    "relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80";

  return (
    <div onClick={isLoading ? null : Update}>
      <div
        style={{
          opacity: isLoading ? 0.6 : 1,
        }}
        className={`${baseStyle} bg-[var(--sell)] text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
      >
        RESET PASSWORD
      </div>
    </div>
  );
}
